import React from "react";
import { Table } from "react-bootstrap";
import { IGetMaillingRulesResponse } from "../../../interfaces/api/IMaillingRules";
import { NavLink } from "react-router-dom";

export default function TableMaillingsRules({ data }: { data: IGetMaillingRulesResponse }) {
    return (
        <div className='table-container'>
            <Table className='table list mailings'>
                <thead>
                    <tr>
                        <th className="name key">Nom</th>
                        <th className="description">Description</th>
                        <th className="clientType">Client(s) cible</th>
                        <th className="period">Période d'exploitation</th>
                        <th className="status">Statut</th>
                        <th className="actions">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {data.maillingRules.length === 0 && (
                        <tr>
                            <td colSpan={5} className="no-data">
                                Aucune donnée disponible
                            </td>
                        </tr>
                    )}
                    {data.maillingRules.length > 0 &&
                        <TableRow data={data} />
                    }
                </tbody>
            </Table>
        </div>
    );
}

function TableRow({ data }: { data: IGetMaillingRulesResponse }) {
    const rows = data.maillingRules.map((maillingRule, indexMaillingRule) => {
        return (
            <tr data-status={maillingRule.status} key={indexMaillingRule}>
                <td className="name key"><NavLink to={"/mailing-rules/" + maillingRule.uuid}>{maillingRule.name}</NavLink></td>
                <td className="description">{maillingRule.description}</td>
                <td className="clientTypes">
                    {maillingRule.client_types.map(clientType => clientType.name).join(", ")}
                </td>
                <td className="period">{maillingRule.start_date} - {maillingRule.end_date}</td>
                <td className="status"><span className="icon"></span><span className="text">{maillingRule.status}</span></td>
                <td className="actions">
                    <div className="btns-wrapper">
                        <NavLink className="btn btn-sm btn-view" title="Voir la configuration d'envoi" to={"/mailing-rules/" + maillingRule.uuid}>
                            <span className="icon"></span><span className="text">Voir</span>
                        </NavLink>
                    </div>
                </td>
            </tr>
        );
    });
    return (
        <>
            {rows}
        </>
    );
}